import { ROUTE_REGISTRY, type RouteDefinition } from './routeRegistry'
import type { RouteKey } from '@omnea-app/fe-routing/routes/routeKeys'

type Registry = typeof ROUTE_REGISTRY

/** A route addressable without caller-supplied values, so a link cannot name one that needs them. */
export type NavigableRouteKey = {
  [Key in RouteKey]: Registry[Key] extends { params: readonly string[] } ? never : Key
}[RouteKey]

/** An optional catch-all matches its own parent path, so the route is entered with the segment absent. */
const OPTIONAL_CATCH_ALL = /\/\[\[\.\.\..+\]\]$/

export const hrefFor = (key: NavigableRouteKey): string => {
  const definition: RouteDefinition = ROUTE_REGISTRY[key]
  if (definition.href != null) return definition.href

  const base = definition.pattern.replace(OPTIONAL_CATCH_ALL, '')
  return definition.segment != null ? `${base}/${definition.segment.value}` : base
}
